import _memoize from 'lodash/memoize';
import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../utils/style';
import { TRANSPARENT } from '../../../utils/colors';
import { identity } from '../../../utils/sizes';
import { HEIGHT as BUTTON_HEIGHT } from '../../../button/button.style';
import { FIRST_BLOCK_PADDING, PADDING, TITLE_PADDING } from '../../../block/block.constants';

export * from '../../../block/block.constants';

export { BUTTON_HEIGHT };

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  title: makeThemeColor(PRIMARY),
};

export const getTitleStyle = _memoize(({ screenSize, colorMode }) => ({
  y: TITLE_PADDING.TOP[screenSize],
  color: colors.title[colorMode],
  text: getFont(FONT.KINSHASA_3, screenSize),
}));

export const getBlockStyle = _memoize(context => {
  const { hasTitle, isFirstBlock, screenSize, isSearchPage } = context;
  const padding = {
    top: PADDING.TOP[screenSize],
    bottom: PADDING.BOTTOM[screenSize],
    left: PADDING.LEFT[screenSize],
  };
  const firstBlockPadding = isSearchPage ? 0 : FIRST_BLOCK_PADDING[screenSize];
  const titleStyle = getTitleStyle(context);
  const items = { y: padding.top };
  const title = { y: titleStyle.y };

  if (hasTitle) {
    items.y = titleStyle.text.lineHeight + TITLE_PADDING.BOTTOM[screenSize];

    if (isFirstBlock) {
      items.y += firstBlockPadding;
      title.y = firstBlockPadding;
    } else {
      items.y += titleStyle.y;
    }
  } else if (isFirstBlock) {
    items.y = firstBlockPadding;
  }

  return { title, items, padding };
});

export const getInitialStyle = (context = defaultContext) => ({
  color: TRANSPARENT,
  Background: {
    w: identity,
    h: identity,
  },
  Content: {
    Title: getTitleStyle(context),
  },
  More: {
    visible: false,
    mountY: 1,
  },
});
